export const medias = () => (
  <path
    d="M8 21h9a4 4 0 0 0 4-4V8M4.667 3h11.666C17.253 3 18 3.746 18 4.667v11.666c0 .92-.746 1.667-1.667 1.667H4.667C3.747 18 3 17.254 3 16.333V4.667C3 3.747 3.746 3 4.667 3"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
